import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {UserDetail} from "../../model/user-detail";

@Component({
  selector: 'user-list-modal',
  templateUrl: './user-list-modal.component.html',
  styleUrls: ['./user-list-modal.component.scss']
})
export class UserListModalComponent {
  @Input() title: string | undefined;
  @Input() users: UserDetail[] | undefined;
  @Input() filteredUsers: UserDetail[] | undefined;

  constructor(public activeModal: NgbActiveModal) {
  }

  sendCouponToUser(user:UserDetail) {
    this.activeModal.close(user);
  }

  onDismissClick(): void {
    /// https://github.com/ng-bootstrap/ng-bootstrap/issues/3721
    this.activeModal.dismiss();
  }

  handleSearchInput(value: string | Event): void {
    let input: string;

    if (typeof value === 'string') {
      input = value.trim();
    } else {
      input = ((value.target as HTMLInputElement).value ?? "").trim();
    }

    if (input.length > 0) {
      this.filteredUsers = this.users?.filter((user: UserDetail) => {
        return user.firstname?.includes(input) ||
          user.lastname?.includes(input) ||
          user.phoneNumber?.includes(input) ||
          user.email?.includes(input);
      });
    } else {
      this.filteredUsers = this.users;
    }
  }
}

